module.exports = __webpack_public_path__ + "static/media/expertise.6ec667a1.png";